import { memo } from "react";
import { Box } from "@mui/material";
import Text from "@/components/Text";
import Theme from "@/utils/theme";
import Divider from "@/components/Divider";
import { QuestionWrapper } from "../../styles";
import Button from "@/components/Button";
import Modal from "@/components/Modal";
import { QuizPointsDialogProps } from "./props.type";
import { ENABLE_POINTS_UI } from "@/utils/feature-flags";

const QuizPointsDialog = ({
  isOpen,
  onClose,
  challenge,
}: QuizPointsDialogProps) => {
  return (
    <Modal
      isOpen={isOpen}
      containerProps={{
        width: { xs: "100%", sm: "50vw" },
      }}
    >
      <Box
        py="1.5rem"
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Text fontSize="1rem" mb="1.5rem">
          {challenge?.title}
        </Text>

        <Box width="90%">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgcolor={Theme.colors.brand.secondary}
            border={`1px solid ${Theme.colors.neutral.mid}`}
            borderRadius="0.2rem"
            p="0.1rem 0"
            sx={{
              width: "calc(101.5% - 0.9rem)",
              transform: { xs: "skew(-10deg)", sm: "skew(-30deg)" },
              marginLeft: "0.9rem",
              marginRight: 0,
              position: "relative",
              minHeight: "3.2rem",
            }}
          >
            <Box
              sx={{
                transform: { xs: "skew(10deg)", sm: "skew(30deg)" },
                position: "absolute",
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Text
                color={Theme.colors.neutral.dark}
                textAlign="center"
                fontSize="1.15rem"
                fontWeight={700}
              >
                PARABÉNS!
              </Text>
            </Box>
          </Box>

          <QuestionWrapper mt={0}>
            <Box
              display="flex"
              flexDirection="column"
              p="1rem"
              alignItems="center"
              justifyContent="center"
            >
              {ENABLE_POINTS_UI ? (
                <>
                  <Text color={Theme.colors.text.secondary} mt="2rem" mb="1.5rem">
                    Pontos Adquiridos:
                  </Text>

                  <QuestionWrapper
                    borderColor={Theme.colors.brand.secondary}
                    p="1rem 1.5rem"
                    flexDirection="row"
                  >
                    <Box>
                      <Text fontSize="2.7rem" color={Theme.colors.brand.secondary}>
                        {challenge.points.earnedPoints} pts
                      </Text>
                    </Box>

                    <Divider vertical margin="0rem 1rem" color="#93999F" />

                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Text color={Theme.colors.text.secondary} fontSize="0.4rem">
                        Pontuação Máxima:
                      </Text>
                      <Text
                        color={Theme.colors.text.secondary}
                        fontSize="1.1rem"
                        fontWeight={300}
                      >
                        {challenge.points.maximumPoints} pts
                      </Text>
                    </Box>
                  </QuestionWrapper>
                </>
              ) : null}

              <Text
                color={Theme.colors.text.secondary}
                mt={ENABLE_POINTS_UI ? "1.5rem" : "2rem"}
                mb="0.5rem"
                textAlign="center"
              >
                Prova concluída. Seu envio foi registrado com sucesso.
              </Text>
            </Box>
          </QuestionWrapper>

          <Box display="flex" width="100%" justifyContent="end" mt="2rem">
            <Button
              fullWidth={false}
              style={{ padding: "0.3rem", width: "8rem" }}
              onClick={onClose}
            >
              Fechar
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default memo(QuizPointsDialog);
